import { create } from "zustand";

interface AuthState {
  token: string | null;
  isAutoLoggedIn: boolean;
  setToken: (token: string | null) => void;
  getToken: () => string | null;
  setIsAutoLoggedIn: (status: boolean) => void;
  getIsAutoLoggedIn: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  token: null,
  isAutoLoggedIn: false,
  setToken: (token) => set({ token }),
  getToken: () => get().token,
  setIsAutoLoggedIn: (status: boolean = false) =>
    set({ isAutoLoggedIn: status }),
  getIsAutoLoggedIn: () => get().isAutoLoggedIn,
}));
